exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".docusign-iframe .iframe-loading{margin-top:150px}.docusign-iframe .loading-label{text-align:center;width:600px}.docusign-iframe .loading-label span{font-size:30px}.docusign-iframe .iframe{top:0;left:0;position:absolute;width:100%}", ""]);

// exports
